/* ============================================
   SPLINE 3D — Product bottle integration
   Loads Spline scene, finds object, animates
   rotation with GSAP ScrollTrigger.
   ============================================ */

import { Application } from 'https://unpkg.com/@splinetool/runtime@1.12.96/build/runtime.js';

(async function () {
  // Skip 3D entirely on mobile — static image is shown instead
  if (window.innerWidth <= 990) {
    window.dispatchEvent(new Event('spline-ready'));
    return;
  }

  var canvas = document.getElementById('spline-canvas');
  if (!canvas) return;

  // Canvas fills viewport — Spline handles aspect internally
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;

  var app = new Application(canvas);

  var sceneUrl = window.__NYMPHAI_SPLINE_URL__ ||
                 (window.__NYMPHAI_ASSETS__ && window.__NYMPHAI_ASSETS__.splineScene) ||
                 'scene.splinecode';
  await app.load(sceneUrl);

  var bottle = app.findObjectByName('nymphai_cosmetic');
  if (!bottle) {
    console.warn('Spline: object "nymphai_cosmetic" not found');
    return;
  }

  // Hero position (starting values)
  var heroX = window.innerWidth <= 1025 ? -300 : -422;
  bottle.position.x = heroX;
  bottle.position.y = 52;
  bottle.position.z = 39;

  bottle.rotation.x = 0;
  bottle.rotation.y = 0;
  bottle.rotation.z = 0;

  // Scale responsive per breakpoint
  var w = window.innerWidth;
  var baseScale = 1.55;
  if (w <= 1024) baseScale = 1.24;       // Laptop: -20%
  else if (w <= 1200) baseScale = 1.30;  // Laptop Windows medio
  else if (w <= 1440) baseScale = 1.40;  // Desktop: -10%
  bottle.scale.x = baseScale;
  bottle.scale.y = baseScale;
  bottle.scale.z = baseScale;

  // Resize canvas when window changes size — maintain aspect ratio
  var resizeTimer;
  var initialWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // If crossing the 990px threshold, reload to switch 3D/static
      if ((initialWidth > 990 && window.innerWidth <= 990) ||
          (initialWidth <= 990 && window.innerWidth > 990)) {
        location.reload();
        return;
      }
      app.setSize(window.innerWidth, window.innerHeight);
    }, 200);
  });

  // Signal that Spline is ready, wait for render frames
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      canvas.style.visibility = 'visible';
      canvas.style.opacity = '1';
      // Dispatch event for preloader
      window.dispatchEvent(new Event('spline-ready'));
    });
  });

  // Idle animations — floating + gentle sway (paused during scroll sections)
  var heroY = bottle.position.y;
  var idleFloat = gsap.to(bottle.position, {
    y: heroY + 8,
    duration: 2.5,
    ease: 'sine.inOut',
    yoyo: true,
    repeat: -1,
  });

  var heroRotZ = bottle.rotation.z;
  var idleSway = gsap.to(bottle.rotation, {
    z: heroRotZ + 0.06,
    duration: 3,
    ease: 'sine.inOut',
    yoyo: true,
    repeat: -1,
  });

  function pauseIdle() {
    idleFloat.pause();
    idleSway.pause();
  }

  function resumeIdle() {
    idleFloat.play();
    idleSway.play();
  }

  // Continuous rotation on Y axis throughout page scroll
  var heroRotY = bottle.rotation.y;
  var continuousRotation = gsap.to(bottle.rotation, {
    y: heroRotY + Math.PI * 12,
    ease: 'none',
    scrollTrigger: {
      trigger: 'body',
      start: 'top top',
      end: 'bottom bottom',
      scrub: 1,
    },
  });


  // --- Section transitions (single timeline to avoid conflicts) ---

  var infoSection = document.querySelector('.dett-info');
  var hscrollSection = document.querySelector('.dett-hscroll-wrap');

  // Hero → Info
  if (infoSection) {
    var tlInfo = gsap.timeline({
      scrollTrigger: {
        trigger: infoSection,
        start: 'top bottom',
        end: 'top 20%',
        scrub: 1.5,
        onEnter: function () { pauseIdle(); },
        onLeaveBack: function () {
          // Reset to hero position when scrolling back to top
          gsap.to(bottle.position, { x: -422, y: heroY, z: 39, duration: 0.5, ease: 'power2.out' });
          gsap.to(bottle.rotation, { x: 0, z: 0, duration: 0.5, ease: 'power2.out', onComplete: resumeIdle });
        },
      },
    });
    tlInfo.to(bottle.position, { x: 208, y: 35, ease: 'power2.inOut' }, 0);
    tlInfo.to(bottle.rotation, { x: -0.120, z: -0.610, ease: 'power2.inOut' }, 0);
  }

  // Info → H-Scroll
  if (hscrollSection) {
    var tlHscroll = gsap.timeline({
      scrollTrigger: {
        trigger: hscrollSection,
        start: 'top bottom',
        end: 'top top',
        scrub: 3,
      },
    });
    tlHscroll.to(bottle.rotation, { x: 0.140, z: -0.130, ease: 'power1.inOut' }, 0);
  }

  // H-Scroll → Perché
  var percheSection = document.querySelector('.dett-perche');
  if (percheSection) {
    var tlPerche = gsap.timeline({
      scrollTrigger: {
        trigger: percheSection,
        start: 'top bottom',
        end: 'top top',
        scrub: 3,
      },
    });
    tlPerche.to(bottle.position, { x: window.innerWidth <= 1025 ? -280 : -429, ease: 'power1.inOut' }, 0);
    tlPerche.to(bottle.rotation, { x: -0.430, z: -0.130, ease: 'power1.inOut' }, 0);
  }

  // Perché → Cerchio: move to final position + lock + auto-rotate
  var cerchioSection = document.querySelector('.dett-cerchio');
  if (cerchioSection) {
    // Transition into cerchio position
    var tlCerchio = gsap.timeline({
      scrollTrigger: {
        trigger: cerchioSection,
        start: 'top bottom',
        end: 'top top',
        scrub: 3,
      },
    });
    var cerchioScale = baseScale * 0.93;
    tlCerchio.to(bottle.position, { x: 124, y: 0, z: 41, ease: 'power1.inOut' }, 0);
    tlCerchio.to(bottle.rotation, { x: 0.130, z: -0.130, ease: 'power1.inOut' }, 0);
    tlCerchio.to(bottle.scale, { x: cerchioScale, y: cerchioScale, z: cerchioScale, ease: 'power1.inOut' }, 0);

    // Auto-rotate Y when cerchio section is in view
    var autoRotate = gsap.to(bottle.rotation, {
      y: '+=6.283',
      duration: 4,
      ease: 'none',
      repeat: -1,
      paused: true,
    });

    // Pin cerchio section so bottle stays centered with the SVG circle
    ScrollTrigger.create({
      trigger: cerchioSection,
      start: 'top top',
      end: '+=100%',
      pin: true,
      onEnter: function () {
        continuousRotation.scrollTrigger.disable(false);
        autoRotate.play();
      },
      onLeaveBack: function () {
        autoRotate.pause();
        continuousRotation.scrollTrigger.enable(false);
      },
      onLeave: function () {
        autoRotate.pause();
        continuousRotation.scrollTrigger.enable(false);
        gsap.to(canvas, { opacity: 0, duration: 0.5 });
      },
      onEnterBack: function () {
        continuousRotation.scrollTrigger.disable(false);
        gsap.set(canvas, { opacity: 1 });
        autoRotate.play();
      },
    });
  }

  // Expose bottle for future section animations
  window._splineBottle = bottle;

  /* ==========================================
     DEBUG PANEL — Disattivato, riattivare se serve
     Per riattivare: cambiare false → true
     ========================================== */
  var SHOW_DEBUG = false;
  if (SHOW_DEBUG) {
  var panel = document.createElement('div');
  panel.id = 'spline-debug';
  panel.innerHTML = `
    <style>
      #spline-debug {
        position: fixed; top: 10px; right: 10px; z-index: 99999;
        background: rgba(0,0,0,0.88); color: #fff; padding: 16px 20px;
        border-radius: 10px; font-family: monospace; font-size: 13px;
        width: 280px; backdrop-filter: blur(8px);
        pointer-events: all;
      }
      #spline-debug h4 { margin: 0 0 12px; font-size: 14px; color: #9FB4C0; }
      #spline-debug label { display: flex; align-items: center; gap: 8px; margin: 6px 0; }
      #spline-debug label span { width: 70px; flex-shrink: 0; }
      #spline-debug input[type=range] { flex: 1; accent-color: #9FB4C0; }
      #spline-debug .val { width: 55px; text-align: right; font-size: 12px; color: #ccc; }
      #spline-debug hr { border: none; border-top: 1px solid rgba(255,255,255,0.15); margin: 10px 0; }
      #spline-debug button {
        width: 100%; padding: 8px; margin-top: 10px; border: none; border-radius: 6px;
        background: #9FB4C0; color: #000; font-weight: bold; font-size: 13px; cursor: pointer;
      }
      #spline-debug button:hover { background: #b8cdd8; }
      #spline-debug .recorded { margin-top: 8px; font-size: 11px; color: #7be07b; display: none; }
    </style>
    <h4>3D Position Debug</h4>

    <label><span>Pos X</span><input type="range" id="dbg-px" min="-500" max="500" step="1" value="${bottle.position.x}"><span class="val" id="dbg-px-v">${bottle.position.x.toFixed(0)}</span></label>
    <label><span>Pos Y</span><input type="range" id="dbg-py" min="-500" max="500" step="1" value="${bottle.position.y}"><span class="val" id="dbg-py-v">${bottle.position.y.toFixed(0)}</span></label>
    <label><span>Pos Z</span><input type="range" id="dbg-pz" min="-500" max="500" step="1" value="${bottle.position.z}"><span class="val" id="dbg-pz-v">${bottle.position.z.toFixed(0)}</span></label>

    <hr>

    <label><span>Rot X</span><input type="range" id="dbg-rx" min="-3.14" max="3.14" step="0.01" value="${bottle.rotation.x}"><span class="val" id="dbg-rx-v">${bottle.rotation.x.toFixed(2)}</span></label>
    <label><span>Rot Y</span><input type="range" id="dbg-ry" min="-3.14" max="3.14" step="0.01" value="${bottle.rotation.y}"><span class="val" id="dbg-ry-v">${bottle.rotation.y.toFixed(2)}</span></label>
    <label><span>Rot Z</span><input type="range" id="dbg-rz" min="-3.14" max="3.14" step="0.01" value="${bottle.rotation.z}"><span class="val" id="dbg-rz-v">${bottle.rotation.z.toFixed(2)}</span></label>

    <hr>

    <label><span>Scale</span><input type="range" id="dbg-s" min="0.1" max="3" step="0.05" value="${bottle.scale.x}"><span class="val" id="dbg-s-v">${bottle.scale.x.toFixed(2)}</span></label>

    <button id="dbg-record">Registra valori</button>
    <div class="recorded" id="dbg-msg">Valori copiati e stampati in console!</div>
  `;
  document.body.appendChild(panel);

  // Slider handlers
  function bindSlider(id, obj, prop, valId) {
    var slider = document.getElementById(id);
    var valEl = document.getElementById(valId);
    slider.addEventListener('input', function () {
      var v = parseFloat(this.value);
      obj[prop] = v;
      valEl.textContent = Math.abs(v) < 10 ? v.toFixed(2) : v.toFixed(0);
    });
  }

  bindSlider('dbg-px', bottle.position, 'x', 'dbg-px-v');
  bindSlider('dbg-py', bottle.position, 'y', 'dbg-py-v');
  bindSlider('dbg-pz', bottle.position, 'z', 'dbg-pz-v');
  bindSlider('dbg-rx', bottle.rotation, 'x', 'dbg-rx-v');
  bindSlider('dbg-ry', bottle.rotation, 'y', 'dbg-ry-v');
  bindSlider('dbg-rz', bottle.rotation, 'z', 'dbg-rz-v');

  // Scale — uniform
  var scaleSlider = document.getElementById('dbg-s');
  var scaleVal = document.getElementById('dbg-s-v');
  scaleSlider.addEventListener('input', function () {
    var v = parseFloat(this.value);
    bottle.scale.x = v;
    bottle.scale.y = v;
    bottle.scale.z = v;
    scaleVal.textContent = v.toFixed(2);
  });

  // Record button
  var recordBtn = document.getElementById('dbg-record');
  var msgEl = document.getElementById('dbg-msg');
  recordBtn.addEventListener('click', function () {
    var data = {
      position: { x: bottle.position.x, y: bottle.position.y, z: bottle.position.z },
      rotation: { x: bottle.rotation.x, y: bottle.rotation.y, z: bottle.rotation.z },
      scale: bottle.scale.x,
    };
    console.log('=== SPLINE 3D — RECORDED VALUES ===');
    console.log(JSON.stringify(data, null, 2));

    var text =
      'position.x = ' + data.position.x.toFixed(1) + ';\n' +
      'position.y = ' + data.position.y.toFixed(1) + ';\n' +
      'position.z = ' + data.position.z.toFixed(1) + ';\n' +
      'rotation.x = ' + data.rotation.x.toFixed(3) + ';\n' +
      'rotation.y = ' + data.rotation.y.toFixed(3) + ';\n' +
      'rotation.z = ' + data.rotation.z.toFixed(3) + ';\n' +
      'scale = ' + data.scale.toFixed(2) + ';';

    navigator.clipboard.writeText(text).catch(function () {});
    console.log(text);

    msgEl.style.display = 'block';
    setTimeout(function () { msgEl.style.display = 'none'; }, 3000);
  });
  } // end SHOW_DEBUG
})();
